import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import type { CalendarDay, CalendarView } from './calendarDates';

/** The period of the toolbar: "October 2026" (Month, List) or "19 – 25 Oct 2026" (Week). */
export function usePeriodTitle(view: CalendarView, days: CalendarDay[], anchor: Date): string {
  const intl = useIntl();
  return useMemo(() => {
    if (view !== 'week' || days.length === 0) {
      return intl.formatDate(anchor, { month: 'long', year: 'numeric' });
    }
    const first = days[0]?.start ?? anchor;
    const last = days[days.length - 1]?.start ?? anchor;
    return intl.formatDateTimeRange(first, last, { day: 'numeric', month: 'short', year: 'numeric' });
  }, [anchor, days, intl, view]);
}
